import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Button, Menu, MenuItem, Stack, Typography } from '@mui/material';
import { StarOutline, AccessPoint, 
// CloseCircleOutline,
// MessageDraw,
// CheckAll,
CalendarMonthOutline, FlagVariantOutline, Check, AccountCheck, ChevronDown, Cancel, CloseCircleOutline } from 'mdi-material-ui';
import { useState } from 'react';
import { MediaPlans } from './Icons';
const options = [
    {
        value: 'new',
        name: 'New',
        color: '#D97008',
        icon: _jsx(StarOutline, { sx: { fontSize: 14 } }),
    },
    // {
    //   value: 'Under Review',
    //   name: 'Under Review',
    //   color: '#D97008',
    //   icon: <MessageDraw sx={{ fontSize: 14 }} />,
    // },
    {
        value: 'Approved',
        name: 'Approved',
        color: 'rgb(21 139 255 / 68%)',
        icon: _jsx(Check, { sx: { fontSize: 14 } }),
    },
    {
        value: "Planning",
        name: "Planning",
        color: "#D97008",
        icon: _jsx(MediaPlans, {})
    },
    {
        value: 'Scheduled',
        name: 'Scheduled',
        color: 'rgb(0 64 127)',
        icon: _jsx(CalendarMonthOutline, { sx: { fontSize: 14 } }),
    },
    {
        value: 'In Execution',
        name: 'In Execution',
        color: '#22A06B',
        icon: _jsx(AccessPoint, { sx: { fontSize: 14 } }),
    },
    {
        value: 'Ended',
        name: 'Ended',
        color: '#FF0000',
        icon: _jsx(FlagVariantOutline, { sx: { fontSize: 14 } }),
    },
    // {
    //   value: 'Closed',
    //   name: 'Closed',
    //   color: '#D01515',
    //   icon: <CheckAll sx={{ fontSize: 14 }} />,
    // },
    {
        value: 'Completed',
        name: 'Completed',
        color: '#850101',
        icon: _jsx(AccountCheck, { sx: { fontSize: 14 } }),
    },
    {
        value: 'Expired',
        name: 'Expired',
        color: '#6B778C',
        icon: _jsx(CloseCircleOutline, { sx: { fontSize: 14 } }),
    },
    {
        value: 'Cancelled',
        name: 'Cancelled',
        color: '#6B778C',
        icon: _jsx(Cancel, { sx: { fontSize: 14 } }),
    },
];
const CampaignStatus = ({ value, allowExpand = false, onClick = () => { }, }) => {
    const option = options.find((item) => item.value === value) || options[0];
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        if (allowExpand)
            setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleSelect = (value) => {
        onClick(value);
        setAnchorEl(null);
    };
    const Status = () => {
        return (_jsxs(Stack, Object.assign({ direction: "row", alignItems: "center", sx: { color: option.color }, spacing: 0.5 }, { children: [option.icon, _jsx(Typography, Object.assign({ variant: "subtitle2", color: option.color }, { children: option.name })), allowExpand && _jsx(ChevronDown, { sx: { fontSize: '16px' } })] })));
    };
    return (_jsx(Box, { children: !allowExpand ? (_jsx(Status, {})) : (_jsxs(_Fragment, { children: [_jsx(Button, Object.assign({ onClick: handleClick }, { children: _jsx(Status, {}) })), _jsx(Menu, Object.assign({ anchorEl: anchorEl, open: open, onClose: handleClose, MenuListProps: {
                        'aria-labelledby': 'basic-button',
                    } }, { children: _jsx(Box, Object.assign({ sx: {
                            borderRadius: '8px',
                            boxShadow: '0px 0px 4px rgba(102, 102, 102, 0.25)',
                            margin: '4px',
                            p: '5px',
                        } }, { children: options.map((item, index) => (_jsxs(MenuItem, Object.assign({ onClick: () => handleSelect(item.value), sx: {
                                display: 'flex',
                                flexDirection: 'row',
                                gap: 0.5,
                                fontSize: 14,
                                color: item.color,
                                alignItems: "center"
                            } }, { children: [item.icon, _jsx(Typography, Object.assign({ variant: "subtitle2", color: item.color }, { children: item.name }))] }), index))) })) }))] })) }));
};
export default CampaignStatus;
